module.exports = __webpack_public_path__ + "img/3d.2f76465d.png";